module.exports = __webpack_public_path__ + "assets/img/detail-btn-07ea6579.png";